<template>
    <div class="dts-header">
        <div class="inner">
            <h3>{{ $i18nUtil.trans("title.CooperationManageHeader.001","회의/협의 카테고리 관리") }} <span>{{ $i18nUtil.trans("message.CooperationManageHeader.001","회의/협의 카테고리를 관리하세요.") }}</span></h3>
            <button type="button" class="btn-primary-smaller"
                    @click="callRegistCategoryModal"
                    v-if="!categoryDetail">
                {{ $i18nUtil.trans("button.category.cfrc.add","카테고리 추가") }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import RegistCategoryModal from "../../modal/RegistCategoryModal";
export default {
    props:["categoryDetail"],
    data(){
        return {

        }
    },
    methods:{
        ...mapActions("modals", ["showModal"]),
        // 회의/협의체 카테고리 추가 모달 호출 
        callRegistCategoryModal(){
            let obj=this;
            const modalInfo = {
                title: obj.$i18nUtil.trans("title.RegistCategoryModal.003","카테고리 추가"),
                name: "registCooperationCategory",
                method: "post",
                width: "800px",
                //height: "500px",
                obj: obj.$modal, 
                component: RegistCategoryModal, 
            };
            obj.showModal(modalInfo);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/cooperation/manage/components/CooperationManageHeader.vue